const _temp0 = require("../extended-ani/ani-script.js");

module.exports = {
  "extended-ani":   {
    "ani-": _temp0
  }
}